import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { css } from "styled-components";

productCardStyles.gridContainer = {
    gap: 0,
    css: css`
        padding: 20px 20px 0 20px;
        min-width: 320px; /* prevent overlap with second column */
    `,
};
